export default "__VITE_ASSET__682d3e59__"